import React from "react";
import {useTranslation} from "react-i18next";
import {Link} from "gatsby-plugin-react-i18next";
import {Storefront, Buildings, ArrowRight} from "@phosphor-icons/react";
/*
 * Dwa wejscia do dzialow branzowych.
 *
 * Zastepuje sekcje "How ChatLab Can Help Your Industry", ktora pokazywala cztery branze
 * jako rowne karty ze zdjeciami stockowymi i nieczytelnymi zrzutami (tekst wielkosci
 * szesciu pikseli).
 *
 * Dlaczego dwa, a nie cztery: linie produktowe sa trzy (uniwersalna, e-commerce,
 * hospitality). Muzea i nieruchomosci nie sa liniami, tylko przykladami zastosowan,
 * i przenosza sie pod /zastosowania. Strona glowna obsluguje linie uniwersalna
 * i ma dwa wyrazne wyjscia do dzialow branzowych.
 *
 * Kazde wejscie niesie liczbe, bo w obu tych branzach liczba jest waluta:
 * w sklepach konwersja, w hotelach wskaznik automatyzacji.
 */

import shopWidget from "../../images/industry/shop-widget.webp";
import hotelWidget from "../../images/industry/hotel-widget.webp";

const ENTRIES = [
    {
        icon: Storefront,
        eyebrow: "For online stores",
        title: "Running a shop?",
        body: "The agent knows your catalogue, recommends products, adds them to the cart and checks order status. Ten platforms, from Shopify to PrestaShop and Shoper.",
        metric: "80%",
        metricLabel: "of enquiries without a human at Black Mountain Honey",
        cta: "See the offer for stores",
        to: "/industry/ecommerce/",
        shot: shopWidget,
        alt: "Product cards inside the chat widget of an online store",
    },
    {
        icon: Buildings,
        eyebrow: "For hotels",
        title: "Running a hotel?",
        body: "The agent answers about availability, rates and stay conditions in the guest's own language, and steers them to a direct booking instead of a portal. Connected to your booking system.",
        metric: "-60%",
        metricLabel: "fewer escalations to the front desk at Umili Resorts",
        cta: "See the offer for hotels",
        to: "/industry/hospitality/",
        shot: hotelWidget,
        alt: "Room offers inside the chat widget of a hotel",
    },
];

const IndustryEntries = () => {
    const {t} = useTranslation();

    return (
        <section className="w-full max-w-screen-2xl mx-auto px-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--cl-rule)] border border-[var(--cl-rule)]">
                {ENTRIES.map(({icon: Icon, ...e}) => (
                    <Link
                        key={e.to}
                        to={e.to}
                        className="group bg-[var(--cl-surface)] p-8 sm:p-10 grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_240px] gap-8 hover:bg-[var(--cl-surface-2)] transition-colors"
                    >
                        <div className="flex flex-col gap-4">
                            <span className="cl-eyebrow flex items-center gap-2">
                                <Icon size={14} weight="regular" color="var(--cl-muted)"/>
                                {t(e.eyebrow)}
                            </span>
                            <h3 className="text-xl sm:text-2xl font-bold text-[var(--cl-ink)]">{t(e.title)}</h3>
                            <p className="text-base leading-relaxed text-[var(--cl-ink-2)] max-w-[46ch]">{t(e.body)}</p>
                            <p className="flex items-baseline gap-2 pt-1">
                                <span className="cl-num text-2xl font-bold text-[var(--cl-accent)]">{e.metric}</span>
                                <span className="text-[13px] text-[var(--cl-muted)]">{t(e.metricLabel)}</span>
                            </p>
                            <span className="mt-auto pt-4 inline-flex items-center gap-2 text-base font-semibold text-[var(--cl-ink)]">
                                {t(e.cta)}
                                <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1"/>
                            </span>
                        </div>
                        <div className="rounded-[4px] border border-[var(--cl-rule)] overflow-hidden bg-white shadow-[0_12px_30px_rgba(17,17,20,0.10)] self-start">
                            <img src={e.shot} alt={t(e.alt)} width={370} height={462} loading="lazy" className="w-full h-auto block"/>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default IndustryEntries;
